"use client";

import { FormEvent, useState } from "react";
import { observer } from "mobx-react";

import styles from "./styles/LoginButtons.module.scss";
import JSONWebToken from "../../../../../utils/JSONWebToken";
import { getConfig } from "../../../../../_configs/AppConfig";
import { IView } from "../../../../../stores/InterfaceStore";
import { useStores } from "../../../../../stores/useStores";
import { ILoginRole } from "./LoginButtons";

const { publicRuntimeConfig } = getConfig();

const MagicLinkForm = observer((props: { role: ILoginRole | "" }) => {
  const { interfaceStore, organizationStore } = useStores();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);

    try {
      const jwt = await new JSONWebToken().encode(
        organizationStore.isMyCleverFeed
          ? undefined
          : organizationStore.organization.id,
        interfaceStore.view === IView.LOGIN
          ? window.location.origin
          : interfaceStore.currentFullUrl,
        props.role,
      );

      const baseWatsonLoginUrl = `https://api.${publicRuntimeConfig.APP_ENV}.cleversite.com/authentication/`;

      const response = await fetch(`${baseWatsonLoginUrl}magic_link_request/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, state: jwt }),
      });

      if (response.ok) {
        setIsSuccess(true);
      } else if (response.status === 429) {
        setErrorMessage("Too many requests. Please wait a few minutes.");
      } else {
        setErrorMessage("Something went wrong. Please try again.");
      }
    } catch {
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (isSuccess) {
    return (
      <div className={styles.magicLinkSuccess}>
        <p>
          We sent a sign-in link to <strong>{email}</strong>
        </p>
      </div>
    );
  }

  return (
    <form className={styles.magicLinkForm} onSubmit={handleSubmit}>
      <input
        className={styles.magicLinkInput}
        type="email"
        placeholder="Email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        disabled={isLoading}
      />
      <button
        className={styles.magicLinkButton}
        type="submit"
        disabled={isLoading}
      >
        {isLoading ? "Sending..." : "Sign in with Email"}
      </button>
      {errorMessage && (
        <div className={styles.magicLinkError}>{errorMessage}</div>
      )}
    </form>
  );
});

export default MagicLinkForm;
